import { useUnit } from 'effector-react';
import { Backdrop, CircularProgress } from '@mui/material';
import { $isReplaceEmployeeLoading } from '../../../../models/replace-employee/replace-employee.model';

export const Loader = () => {
  const isReplaceEmployeeLoading = useUnit($isReplaceEmployeeLoading);

  return (
    <Backdrop open={isReplaceEmployeeLoading} sx={{ zIndex: 2000 }}>
      <CircularProgress />
    </Backdrop>
  );
};
